import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter!');
      e.target.reset();
    } catch (error) {
      console.error('Newsletter error:', error);
      toast.error('Failed to subscribe. Please try again.');
    }
  };

  return (
    <footer className="bg-[#0a1128] text-white">
      {/* Newsletter Section */}
      <div className="border-b border-gray-800">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl font-display font-bold text-[#D4AF37] mb-2">
                Join Our Exclusive Club
              </h3>
              <p className="text-gray-400">
                Subscribe for premium offers, new arrivals, and expert tips
              </p>
            </div>
            <form onSubmit={handleNewsletterSubmit} className="flex w-full md:w-auto gap-2">
              <Input
                type="email"
                name="email"
                placeholder="Enter your email"
                required
                className="md:w-80 bg-white/10 border-gray-700 text-white placeholder:text-gray-400"
              />
              <Button type="submit" className="bg-[#D4AF37] hover:bg-[#C5A028] text-[#0a1128]">
                <Mail className="h-4 w-4 mr-2" />
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              {/* Hookah Crest Logo with 3D Effect */}
              <div className="relative group">
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#FFD700] to-[#B8860B] blur-md opacity-50 group-hover:opacity-75 transition-opacity"></div>
                <div className="relative w-12 h-12 rounded-full bg-gradient-to-br from-[#D4AF37] via-[#FFD700] to-[#C5A028] flex items-center justify-center shadow-2xl border-2 border-[#FFD700]/30">
                  <div className="absolute inset-1 rounded-full bg-gradient-to-br from-white/20 to-transparent"></div>
                  <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    className="w-8 h-8 relative z-10"
                  >
                    {/* Hookah Base */}
                    <path
                      d="M32 48C28 48 25 45 25 42L25 38L39 38L39 42C39 45 36 48 32 48Z"
                      fill="#0a1128"
                      opacity="0.9"
                    />
                    {/* Water in base */}
                    <ellipse cx="32" cy="38" rx="7" ry="2" fill="#4A90E2" opacity="0.6"/>
                    
                    {/* Hookah Stem */}
                    <rect x="30" y="25" width="4" height="13" fill="#0a1128" opacity="0.9"/>
                    
                    {/* Bowl */}
                    <path
                      d="M27 20C27 18 29 16 32 16C35 16 37 18 37 20L37 25L27 25L27 20Z"
                      fill="#0a1128"
                      opacity="0.9"
                    />
                    
                    {/* Hot Coals */}
                    <circle cx="29" cy="18" r="1.5" fill="#FF6B35"/>
                    <circle cx="32" cy="17" r="1.5" fill="#FF8C42"/>
                    <circle cx="35" cy="18" r="1.5" fill="#FF6B35"/>
                    
                    {/* Smoke/Flame effect - wavy abstract */}
                    <path
                      d="M32 15 Q30 12 31 9 Q32 11 32 8 Q32 11 33 9 Q34 12 32 15"
                      stroke="#D4AF37"
                      strokeWidth="1"
                      fill="none"
                      opacity="0.7"
                    />
                    <path
                      d="M28 14 Q27 11 28 9"
                      stroke="#FFD700"
                      strokeWidth="0.8"
                      fill="none"
                      opacity="0.6"
                    />
                    <path
                      d="M36 14 Q37 11 36 9"
                      stroke="#FFD700"
                      strokeWidth="0.8"
                      fill="none"
                      opacity="0.6"
                    />
                    
                    {/* Hoses */}
                    <path
                      d="M25 35 Q20 35 18 37"
                      stroke="#0a1128"
                      strokeWidth="2"
                      fill="none"
                      opacity="0.8"
                    />
                    <path
                      d="M39 35 Q44 35 46 37"
                      stroke="#0a1128"
                      strokeWidth="2"
                      fill="none"
                      opacity="0.8"
                    />
                  </svg>
                  {/* Bottom shine effect */}
                  <div className="absolute bottom-1 left-1/2 -translate-x-1/2 w-6 h-2 bg-white/40 rounded-full blur-sm"></div>
                </div>
              </div>
              <div className="text-2xl font-display font-bold">
                Smithhookahsupplyco
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Premium hookah supply since 2025. Experience luxury in every session.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://facebook.com" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://youtube.com" className="text-gray-400 hover:text-[#D4AF37] transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-lg font-semibold text-[#D4AF37] mb-4">Shop</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-gray-400 hover:text-white transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/products?category=hookahs" className="text-gray-400 hover:text-white transition-colors">
                  Hookahs
                </Link>
              </li>
              <li>
                <Link to="/products?category=tobacco" className="text-gray-400 hover:text-white transition-colors">
                  Tobacco
                </Link>
              </li>
              <li>
                <Link to="/products?category=accessories" className="text-gray-400 hover:text-white transition-colors">
                  Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold text-[#D4AF37] mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/event-catering" className="text-gray-400 hover:text-white transition-colors">
                  Event Catering
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Shipping Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  Return Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-[#D4AF37] mb-4">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a href="tel:407-702-0465" className="text-gray-400 hover:text-white transition-colors">
                  407-702-0465
                </a>
              </li>
              <li>
                <a href="mailto:Smithhookahsupplyco@gmail.com" className="text-gray-400 hover:text-white transition-colors">
                  Smithhookahsupplyco@gmail.com
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact Form
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-gray-400 hover:text-white transition-colors">
                  My Account
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Smithhookahsupplyco. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;